// The core's question before leaving unsaved work (DESIGN.md «Несохранённые изменения»): one dialog for every screen, the
// frame shows it when shell/unsaved.ts asks. Escape and a click beside it mean «Остаться» — nothing is lost by accident.

import { Button, Dialog } from './primitives.tsx';
import s from './ui.module.css';

export function LeaveDialog({ what, saving, onAnswer }: { what: string[]; saving: boolean; onAnswer: (c: 'save' | 'discard' | 'stay') => void }) {
  return (
    <Dialog open onOpenChange={(o) => { if (!o && !saving) onAnswer('stay'); }} label="Несохранённые изменения">
      <div className={s.confirm}>
        <h2 className={s.confirmTitle}>Сохранить изменения?</h2>
        <p className={s.confirmText}>Не сохранено: {what.join(', ')}. Если уйти без сохранения, изменения пропадут.</p>
        <div className={s.confirmActions}>
          <Button onClick={() => onAnswer('stay')} disabled={saving}>Остаться</Button>
          <span className={s.confirmGap} />
          <Button variant="danger" onClick={() => onAnswer('discard')} disabled={saving}>Не сохранять</Button>
          <Button variant="primary" onClick={() => onAnswer('save')} disabled={saving}>{saving ? 'Сохраняю…' : 'Сохранить'}</Button>
        </div>
      </div>
    </Dialog>
  );
}
